<template>
	<page>
		<module title="交易统计" enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="统计时间" colspan="2">
					<c-datetime start-name="start_date" end-name="end_date" type="date" range></c-datetime>
				</m-search-item>
			</m-search>
			
			<c-table ref="table" height="grow">
				<c-table-column
					label="日期"
					name="statistic_date"
				>
				</c-table-column>
				
				<c-table-column
					label="订单数"
					name="order_count"
				>
				</c-table-column>
				
				<c-table-column
					label="销量"
					name="sales_quantity"
				>
				</c-table-column>
				
				<c-table-column
					label="交易总额"
					name="sales_amount"
				>
					<template v-slot="{data}">
						￥{{data.sales_amount}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="支付人数"
					name="pay_user_quantity"
				>
				</c-table-column>
				
				<c-table-column
					label="取消单数"
					name="cancel_order_count"
				>
				</c-table-column>
				
				<c-table-column
					label="取消数量"
					name="cancel_quantity"
				>
				</c-table-column>
				
				<c-table-column
					label="取消总额"
					name="cancel_amount"
				>
					<template v-slot="{data}">
						￥{{data.cancel_amount}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="退款数量"
					name="refund_quantity"
				>
				</c-table-column>
				
				<c-table-column
					label="退款总额"
					name="refund_amount"
				>
					<template v-slot="{data}">
						￥{{data.refund_amount}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="退货数量"
					name="return_quantity"
				>
				</c-table-column>
				
				<c-table-column
					label="退货总额"
					name="return_amount"
				>
					<template v-slot="{data}">
						￥{{data.return_amount}}
					</template>
				</c-table-column>
			</c-table>
		</module>
		
	</page>
</template>

<script>
	export default {
		name: 'm_trans_analysis',
		
		data() {
			return {
				
			}
		},
		
		computed: {
			powerAllCheck() {
				
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/statistic/trans/list',
					data
				});
			}
		}
	}
</script>